import { render, staticRenderFns } from "./ContractDocuments.vue?vue&type=template&id=510b0012&scoped=true&"
import script from "./ContractDocuments.vue?vue&type=script&lang=js&"
export * from "./ContractDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510b0012",
  null
  
)

export default component.exports